
    import Alert from '@/components/Alert';
import PercentBox from "@/components/shared/PercentBox.vue";
import { backendExceptionHandler, companyLogoHandler, paginationStateHandler } from "@/mixins";
import FormatterService from "@/service/FormatterService";
import { sortHandler } from "../../mixins";
import CdnService from "../../service/CdnService";

    export default {
        name: 'ShareQuotes',
        mixins: [ backendExceptionHandler, sortHandler, paginationStateHandler, companyLogoHandler ],
        components: {
            Alert,
            PercentBox,
        },
        props: {
            share: Object,
            quotes: Array,
        },

        data () {
            return {
                sortDesc: true,
                format: new FormatterService(),
                quoteRefreshTimerId: null,
                errorMessage: null,
            }
        },

        computed: {
            headers() {
                return [
                    { text: this.$t('component.share.shareQuotes.headers.exchange'), value: 'mic' },
                    { text: this.$t('component.share.shareQuotes.headers.ticker'), value: 'ticker', width: '100px' },
                    { text: this.$t('component.share.shareQuotes.headers.currency'), value: 'currency', width: '110px' },
                    { text: this.$t('component.share.shareQuotes.headers.lastTrade'), value: 'date', width: '160px' },
                    { text: this.$t('component.share.shareQuotes.headers.price'), value: 'price', width: '130px' },
                    { text: this.$t('component.share.shareQuotes.headers.dailyChange'), value: 'change', width: '200px' },
                ];
            },
        },

        methods: {
            updateErrorMessage() {
                this.errorMessage = ""
            },

            getStockLogoClass(logo) {
                return 'exchange-logo ' + (
                    (logo && logo != null)
                        ? 'company-logo'
                        : 'company-logo-invalid'
                )
            },
        },

        created() {
            this.cdnService = new CdnService()
        }
    }
